import React from "react";
import * as Icons from "@material-ui/icons";

const DynamicIcon = (props) => {
  const { ...iconLogo } = Icons;
  const IconDisplay = iconLogo[props.iconName];
  const DefaultIcon = iconLogo["Help"];

  return !IconDisplay ? (
    <DefaultIcon fontSize={props.fontSize} />
  ) : (
    <IconDisplay fontSize={props.fontSize} />
  );
};

export default DynamicIcon;